import './progress_bar_modal.less';
import '../components/modal/modal.less';

import React from 'react';
import {Link, browserHistory} from 'react-router';
import {toUpperCase} from '../util/common';
import ShowError from '../components/error/show_error';
import ImageUpload from '../image_upload/image_upload';
import Map from '../components/map_component/map_component';
import Rating from '../components/rating/rating';
import fileUploadActions from '../image_upload/file_upload_actions';
import validate from '../util/validate';
import {join} from '../util/common';

//Intro popup step 1
class PackageDelivery extends React.Component{
    constructor(props){
      super(props);
      this.state = {}
    }
    render(){
      const {state, props} = this;
      return(
        <div className = "modal-content-wrap">
          <div className="content-hdr">{props.isPackageDelivery ? "PackageDelivery" : "PackageDelivery"}</div>
          <div className = "content">
            <div className = "checked-img" style = {{"backgroundImage": 'url("' + '../../public/images/account/checked-orange.svg' + '")'}}></div>
            <div className = "right-content-wrap">
              <div className = "title">{toUpperCase("meet with recipient")}</div>
              <div className = "sub-title">Meet at the agreed upon location & time</div>
            </div>
          </div>
          <div className = "content">
            <div className = "checked-img" style = {{"backgroundImage": 'url("' + '../../public/images/account/checked-orange.svg' + '")'}}></div>
            <div className = "right-content-wrap">
              <div className = "title">TAKE A PICTURE OF THE PACKAGE WITH RECIPIENT</div>
              <div className = "sub-title">This verifies the package is with the recipient</div>
            </div>
          </div>
          <div className = "content">
            <div className = "checked-img" style = {{"backgroundImage": 'url("' + '../../public/images/account/checked-orange.svg' + '")'}}></div>
            <div className = "right-content-wrap">
              <div className = "title">ENTER 6-DIGIT CONFIRMATION CODE FROM RECIPIENT</div>
              <div className = "sub-title">This completes the delivery process.</div>
            </div>
          </div>
          <div className = "content start-btn-wrap">
            <button className = "btn orange" onClick = {this.props.startDelivery.bind(self,props.startDelivery)}>Start</button>
          </div>
          <div className = "content">
            <div className = "legal-content">Please use your discretion when carrying items.  Verify package contents are safe to carry. It is illegal to carry firearms, weapons, or illegal substances.</div>
          </div>
        </div>
      )
    }
}

//Shipper and Recipient Info Modal step 2
class MeetRecipient extends React.Component{
    constructor(props){
      super(props);
      this.state = {}
    }
    render(){
      const {state, props} = this;
      const {shipperInfo,recipientInfo} = props;
      const recipientimageUrl = recipientInfo.profileImgUrl || "../../public/images/user_placeholder.svg";
      const shipperImageUrl = shipperInfo.profileImgUrl || "../../public/images/user_placeholder.svg";

      return(
        <div className = "modal-content-wrap meet-shipper-modal">
          <div className="content-hdr">Meet with Recipient</div>
          <div className = "info-content">{this.props.deliveryLocation}</div>
          <Map lat = {props.deliveryLat} lng = {props.deliveryLong}/>
          <div className = "content start-btn-wrap">
            <button className = "btn orange pickup-location-btn"
                    onClick = {this.props.arrivedAtDestination}>
              I'm at the Delivery Location
            </button>
          </div>

          <div className = "info-header">Shipper</div>
          <div className = "shipper-info-wrap">
            <div className = "left-content-wrap">
              <div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + shipperImageUrl + '")'}}></div>
              <div className = "shipper-info">
                <div className = "name">{shipperInfo.name}</div>
                <div className="rating"><Rating rating={shipperInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({shipperInfo.totalNoOfRatings})</span></div>
                <div className = "phone-number">{shipperInfo.phoneNumber}</div>
              </div>
            </div>
            <div className = "right-content-wrap">
              {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/call.png' + '")'}}></div>*/}
              {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/message.png' + '")'}}></div>*/}
            </div>
          </div>
          <div className = "info-header">Recipient</div>
          <div className = "shipper-info-wrap">
            <div className = "left-content-wrap">
              <div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + recipientimageUrl + '")'}}></div>
              <div className = "shipper-info">
                <div className = "name">{recipientInfo.name}</div>
                <div className="rating"><Rating rating={recipientInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({recipientInfo.totalNoOfRatings})</span></div>
                <div className = "phone-number">{recipientInfo.phoneNumber}</div>
              </div>
            </div>
            <div className = "right-content-wrap">
              {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/call.png' + '")'}}></div>*/}
              {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/message.png' + '")'}}></div>*/}
            </div>
          </div>
        </div>
      )
    }
}

//Identity modal step 3
class VerifyIdentity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render(){
    const {state, props} = this;
    const {recipientInfo} = props;
    const imageUrl = recipientInfo.profileImgUrl || "../../public/images/user_placeholder.svg";
    console.log("confirm identity============", this.props);
    return(
      <div className = "modal-content-wrap verify-identity-modal">
        <div className="content-hdr">Verify recipient’s identity</div>
        <div className = "content-sub-hdr">
          Ask to see the recipient’s driver’s license or equivalent ID to verify that they are in fact the recipient you are scheduled to meet.
        </div>
        <div className = "info-header">Recipient</div>
        <div className = "shipper-info-wrap">
          <div className = "left-content-wrap">
            <div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + imageUrl + '")'}}></div>
            <div className = "shipper-info">
              <div className = "name">{recipientInfo.name}</div>
              <div className="rating"><Rating rating={recipientInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({recipientInfo.totalNoOfRatings})</span></div>
              <div className = "phone-number">{recipientInfo.phoneNumber}</div>
            </div>
          </div>
          <div className = "right-content-wrap">
            {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/call.png' + '")'}}></div>*/}
            {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/message.png' + '")'}}></div>*/}
          </div>
        </div>
        <div className = "confirm-btn-wrap">
          <button className = "btn orange" onClick={this.props.onConfirmIdentity}>Confirm Identity</button>
        </div>
      </div>
    )
  }
}

class UploadPicture extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render(){
    return(
      <div className = "modal-content-wrap meet-shipper-modal">
        <div className="content-hdr">Take a picture of the package with the recipient</div>
        <div className = "content-sub-hdr">
          This verifies the package was delivered to the right person.
        </div>
        <ImageUpload getImageUrlCallback = {this.props.onImgUpload}/>
      </div>
    )
  }
}

class ConfirmCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: ''
    }
    this.inputChange = this.inputChange.bind(this);
  }

  inputChange(name, event) {
      const stateObj = {};
      const inputVal = event.target.value;
      if(inputVal.length>6) return false;
      stateObj[name] = event.target.value;
      this.setState(stateObj);
  }

  sendConfirmCode = (e) => {

    e.preventDefault();
    const {confirmCode} = this.state;
    this.setState({error : ""});

    // let validationErrorMsg = '';
    //
    // const validationError = {confirmCode: !validate.confirmCode(confirmCode)};
    // const validationMap = {confirmCode: 'confirmCode'};
    //
    // const validationFields = [];
    //
    // Object.keys(validationError).forEach((key) => {
    //     if (validationError[key]) {
    //         validationFields.push(validationMap[key]);
    //     }
    // });
    //
    // if (validationFields.length) {
    //     validationErrorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
    //         if (validationFields.length === 1)
    //             return "";
    //         if (idx > 0 && idx < validationFields.length - 1)
    //             return ", ";
    //         else if (idx === validationFields.length - 1)
    //             return " and ";
    //         return "";
    //     }) + '.';
    // }
    //
    // if (validationErrorMsg) {
    //     this.setState({error: validationErrorMsg});
    //     return;
    // }
    this.setState({ajaxInProgress: true});
    this.props.completeDelivery(confirmCode);
  }

  render(){

    return(
      <form className = "modal-content-wrap confirm-code-modal">
        {/*
          this.props.error && <ShowError errorMessage = {this.props.error} />
        */}
        <div className="content-hdr">Ask for the 6-digit confirmation code to confirm delivery</div>
        <div className = "input-code">
          <input type="text"
                 placeholder = "6-digit confirmation code"
                 className = "form-input confirm-code-ip"
                 name = "confirmCode"
                 onChange={this.inputChange.bind(self, 'confirmCode')}
                 maxLength="6" >
          </input>
        </div>
        <div className = "confirm-btn-wrap">
          <button type = "submit" className = "btn orange" onClick = {this.sendConfirmCode}>Next</button>
        </div>
      </form>
    )
  }
}

class ProgressBarModal extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isOpen : props.isOpen,
        showMeetWithRecipient: props.showMeetWithRecipient,
        showUploadPicture : props.showUploadPicture,
        showSucessPopup: false,
        error: props.error,
        shipperInfo: props.shipperInfo,
        showConfirmCodeModal: props.showConfirmCodeModal,
        showVerifyIdentityModal: props.showVerifyIdentityModal,
        recipientInfo: props.recipientInfo,
        deliveryLocation: props.deliveryLocation,
        deliveryLat: props.deliveryLat,
        deliveryLong: props.deliveryLong
      }
      this.startDelivery = this.startDelivery.bind();
      // this.meetWithShipper = this.meetWithShipper.bind();
      this.onImgUpload = this.onImgUpload.bind();
    }

    componentWillReceiveProps(newProps){
      this.setState({ isOpen:newProps.isOpen,
                      showMeetWithRecipient:newProps.showMeetWithRecipient,
                      error: newProps.error,
                      shipperInfo: newProps.shipperInfo,
                      recipientInfo: newProps.recipientInfo,
                      showConfirmCodeModal: newProps.showConfirmCodeModal,
                      showVerifyIdentityModal: newProps.showVerifyIdentityModal,
                      recipientInfo: newProps.recipientInfo,
                      showUploadPicture: newProps.showUploadPicture,
                      deliveryLocation: newProps.deliveryLocation,
                      deliveryLat: newProps.deliveryLat,
                      deliveryLong: newProps.deliveryLong
                    })
    }
    close = () => {
      this.props.onClose();
    }

    startDelivery = (isStartHandoff) => {
      // this.setState({showMeetWithRecipient:true})
      this.props.startDelivery();
    }

    onImgUpload = (imgSrc) => {
      // this.setState({showSucessPopup:true});
      this.props.onReciepentImgUpload(imgSrc);
    }

    render() {
      const self = this;
      const {props,state} = this;

      let modalContent = <PackageDelivery {...this.props} startDelivery = {this.startDelivery}/>;

      if(state.showConfirmCodeModal){
        modalContent = <ConfirmCode completeDelivery = {this.props.completeDelivery} error = {state.error}/>
      }
      else if (state.showUploadPicture && state.showVerifyIdentityModal && !props.error) {
        modalContent = <UploadPicture onImgUpload = {this.onImgUpload}/>
      }
      else if(state.showVerifyIdentityModal){
        modalContent = <VerifyIdentity
                          recipientInfo = {state.recipientInfo}
                          onConfirmIdentity={this.props.onConfirmIdentity}
                       />
      }
      else if(state.showMeetWithRecipient && !state.error){
        modalContent = <MeetRecipient
          shipperInfo = {state.shipperInfo}
          meetWithRecipient={this.meetWithRecipient}
          recipientInfo = {state.recipientInfo}
          deliveryLocation = {state.deliveryLocation}
          arrivedAtDestination = {this.props.arrivedAtDestination}
          deliveryLat = {state.deliveryLat}
          deliveryLong = {state.deliveryLong}
          />
      }

      return (
          <div className={state.isOpen? 'modal-popup': 'displayNone'}>
            <div className="overlay"></div>
            <div className="modal package-modal">
              {
                state.error && <ShowError errorMessage = {state.error} />
              }
              <div className="content-wrap">
                <div className="close-button">
                  <span className="icon-cross-feather cursor-pointer" onClick={this.close}></span>
                </div>
                {modalContent}
              </div>
            </div>
          </div>
        )
    }
}

export default ProgressBarModal;



// WEBPACK FOOTER //
// app/shipment/package_delivery_modal.jsx